import { render, staticRenderFns } from "./ChocolateProductsSection.vue?vue&type=template&id=44d978a0&"
import script from "./ChocolateProductsSection.vue?vue&type=script&lang=js&"
export * from "./ChocolateProductsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports